import mixitup from "mixitup"
import mixitupMultifilter from '../js/mixitup/mixitup-multifilter.min.js'
import mixitupPagination from '../js/mixitup/mixitup-pagination.min.js'

const noResultsText = document.querySelector('.flow__no-results') as HTMLParagraphElement

/**
 * Interface for object to store active filter data
 */
interface QueryStringObject {
    page?: number,
    type?: string,
    region?: string
}

/**
 * Create an instance of QueryStringObject from a search-string (URI)
 * @param str a search string, e.g. 'orderby=default&color=red&page=2'
 * @returns an instance of QueryStringObject
 */
const createQueryObjectFromString = (str: string): QueryStringObject => {
    const query: QueryStringObject = {
        page: 1,
        type: '',
        region: ''
    }

    /**
     * Divide input string into filter property groups, populate
     * query object with data from input string.
     */
    const splitString = str.split('&')
    splitString.forEach((s) => {
        if (s.includes("page")) query.page = parseInt(s.split("=")[1])
        if (s.includes("type")) query.type = s.split("=")[1]
        if (s.includes("region")) query.region = s.split("=")[1]
    })

    return query
}

/**
 * Create a search string from an object
 * @param query an instance of QueryStringObject
 * @returns a search string
 */
const createSearchString = (query: QueryStringObject): string => {
    let str = ""

    str += query.page > 0 ? "page=" + query.page : 1
    str += query.type != "" ? "&type=" + query.type : ""
    str += query.region != "" ? "&region=" + query.region : ""

    return str
}

/**
 * Update search string to reflect current active filters
 */
const updateSearchString = () => {
    const activePage = document.querySelector('.page.page-active')
    const currentPage = activePage ? parseInt(activePage.getAttribute('data-page')) : 1
    
    const activeTypes = document.querySelectorAll('.flow__filter__control--type.control-active:not(.flow__filter__control--show-all)')
    let typeString = ""

    if (activeTypes.length > 0)
    {
        activeTypes.forEach((type) => {
            typeString += type.getAttribute('data-label-clean') + ','
        })
    }

    const activeRegions = document.querySelectorAll('.flow__filter__control--region.control-active:not(.flow__filter__control--show-all)')
    let regionString = ""

    if (activeRegions.length > 0)
    {
        activeRegions.forEach((region) => {
            regionString += region.getAttribute('data-label-clean') + ','
        })
    }

    const queryObject : QueryStringObject = {
        page: currentPage,
        type: typeString.replace(/,$/, ""),
        region: regionString.replace(/,$/, "")
    }
    const searchString = createSearchString(queryObject)

    window.history.replaceState({}, "", "?" + searchString)
}

/**
 * Activate/set filters. Called on page load
 * Creates an object from the current search string in the URL and
 * uses Mixitup Mulitifilter API to activate filters
 * @param mixer an instance of Mixitup
 */
const activateFilters = (mixer: any) => {
    if (window.location.search.length > 1) {
        const initialQuery: QueryStringObject = createQueryObjectFromString(window.location.search)
        console.log(initialQuery)
        if (mixer != null)
        {
            const typeQueryArr = initialQuery.type.split(',')
            const typeSelectorsArr = []
            if (typeQueryArr[0].trim() != '')
            {
                typeQueryArr.forEach((type) => {
                    typeSelectorsArr.push('[data-type~=' + type + ']')
                })
            } 

            if (document.querySelector('[data-filter-group="type"]')) {
                mixer.setFilterGroupSelectors('type', typeSelectorsArr)
            }

            const regionQueryArr = initialQuery.region.split(',')
            const regionSelectorsArr = []
            if (regionQueryArr[0].trim() != '')
            {
                regionQueryArr.forEach((region) => {
                    regionSelectorsArr.push('[data-region~=' + region + ']')
                })
            } 

            if (document.querySelector('[data-filter-group="region"]')) {
                mixer.setFilterGroupSelectors('region', regionSelectorsArr)
            }

            // Parse filter groups
            mixer.parseFilterGroups()

            // Paginate
            const currentPage = initialQuery.page > 0 ? initialQuery.page : 1
            mixer.paginate(currentPage)
        }
    }
    else if (mixer != null)
    {
        mixer.paginate(1)
    }
}

/**
 * Set show all to active if no active filters
 */
const showAllActive = () => {
    const filterFieldsets = document.querySelectorAll('fieldset[data-filter-group]') as NodeListOf<HTMLFieldSetElement>
    if (filterFieldsets.length > 0) {
        filterFieldsets.forEach(fieldset => {
            if (fieldset.querySelectorAll('.control-active').length < 1 && fieldset.querySelector('.flow__filter__control--show-all')) {
                fieldset.querySelector('.flow__filter__control--show-all').classList.add('control-active')
            }
        })
    }
}

/**
 * Update label on regions dropdown
 */
const regionFilterToggle = document.querySelector('.flow__filter__dropdown__toggle') as HTMLButtonElement
const updateDropdownLabel = () => {
    const activeRegion = document.querySelector('.flow__filter__control--region.control-active:not(.flow__filter__control--show-all)') as HTMLButtonElement
    let label

    if (activeRegion) {
        label = activeRegion.innerText
    } else
    {
        label = 'Visa alla'
    }

    if (regionFilterToggle) regionFilterToggle.innerText = label
}

/**
 * Toggle off filter TODO:
 */
// const filterTypeButtons = document.querySelectorAll('.flow__filter__control--type:not(.flow__filter__control--show-all)')
// const initTypeButtonListener = (mixer: any) => {
//     filterTypeButtons.forEach(button => {
//         button.addEventListener('click', () => {
//             if (button.classList.contains('control-active') && mixer != null) {
//                 console.log(mixer.getState())
//                 const typeSelectorsArr = ['']
//                 if (document.querySelector('[data-filter-group="type"]')) {
//                     mixer.setFilterGroupSelectors('type', typeSelectorsArr)
//                 }
//                 mixer.parseFilterGroups()
//                 mixer.paginate(1)
//             }
//         })
//     })
// }

/**
 * Update header to fit current filter
 */
const h1 = document.querySelector('h1') as HTMLHeadingElement
const preambles = document.querySelectorAll('.page-header__preamble') as NodeListOf<HTMLDivElement>

const updatePageHeader = () => {
    const activeType = document.querySelector('.flow__filter__control--type.control-active')
    const type = activeType != null && !activeType.classList.contains('flow__filter__control--show-all') ? activeType?.getAttribute('data-label-clean') : 'all'

    h1.querySelectorAll('span').forEach(span => {
        span.style.display = 'none'
    })
    preambles.forEach(preamble => {
        preamble.style.display = 'none'
    })

    let h1match
    let preambleMatch
    
    h1match = h1.querySelector('.page-header__heading__inner[data-type="' + type + '"]') as HTMLSpanElement
    preambleMatch = document.querySelector('.page-header__preamble[data-type="' + type + '"]') as HTMLDivElement

    h1match.style.display = 'block'
    preambleMatch.style.display = 'block'
}

/**
 * Function to call on mix end
 */
const mixEndFunction = (mixer: any) => {
    if (noResultsText) noResultsText.style.display = 'none'
    updateSearchString()
    showAllActive()
    updatePageHeader()
    updateDropdownLabel()
}

/**
 * Export function
 */
export default function initFlowFilter()
{
    const mixContainer = document.querySelector('#flow__items') as HTMLElement
    mixitup.use(mixitupMultifilter)
    mixitup.use(mixitupPagination)

    const pageLimit = 12

    /**
     * Initialize mixer
     */
    let mixer

    if (mixContainer)
    {
        mixer = mixitup(mixContainer, {
            selectors: {
                target: '.flow__item'
            },
            animation: {
                enable: false
            },
            multifilter: {
                enable: true
            },
            classNames: {
                elementPager: 'page',
                block: ''
            },
            pagination: {
                limit: pageLimit,
                hidePageListIfSinglePage: true
            },
            callbacks: {
                onMixEnd: () => {
                    mixEndFunction(mixer)
                },
                onPaginateEnd: () => {
                    document.querySelector('.page-header')?.scrollIntoView()
                    // setDisabledOnPaginate(mixer)
                },
                onMixFail: () => {
                    if (noResultsText) noResultsText.style.display = 'block'
                }
            },
            templates: {
                pagerPrev: `
                    <button type="button" class="prev" data-page="prev" aria-label="Föregående sida">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="#B73C3D"/>
                            <path d="M15 10L25 20L15 30" stroke="white" stroke-width="1.5"/>
                        </svg>
                    </button>
                `,
                pagerNext: `
                    <button type="button" class="next" data-page="next" aria-label="Nästa sida">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="#B73C3D"/>
                            <path d="M15 10L25 20L15 30" stroke="white" stroke-width="1.5"/>
                        </svg>
                    </button>
                `
            }
        })
    }

    /**
     * Set filters on load
     */
    activateFilters(mixer)

    /**
     * Set show all as active on load
     */
    showAllActive()

    /**
     * Init listener on type buttons
     */
    // initTypeButtonListener(mixer)
}